// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import XngZone from "@rpsc/App/Components/Common/XngZone";
import StyledBox from "@rpsc/XDL/Components/Common/Box";
import { Divider } from "@rpsc/XDL/Utilities";
import React, { FC } from "react";

export interface CreateAccountPageLayoutStyles {
    wrapper?: InjectableCss;
    container?: InjectableCss;
    innerWrapper?: InjectableCss;
    siteMessageWrapper?: InjectableCss;
}

export const createAccountPageLayoutStyles: CreateAccountPageLayoutStyles = {};

const styles = createAccountPageLayoutStyles;

const CreateAccountPageLayout: FC<WidgetProps> = ({ id }) => {
    return (
        <StyledWrapper {...styles.wrapper} data-test-selector="CreateAccountPageLayout">
            <StyledWrapper>
                <XngZone contentId={id} zoneName="Content01" hint="PageTitle" />
            </StyledWrapper>
            <StyledWrapper {...styles.siteMessageWrapper}>
                {siteMessage("Custom_CreateAccountPage_Message")}
            </StyledWrapper>
            <StyledBox {...styles.container}>
                <StyledWrapper {...styles.innerWrapper}>
                    <XngZone contentId={id} zoneName="Content03" hint="AlignWithExistingAccount" />
                </StyledWrapper>
                <Divider margin="0 32px" direction="vertical" />
                <StyledWrapper {...styles.innerWrapper}>
                    <XngZone contentId={id} zoneName="Content04" hint="CreateNewAccount" />
                </StyledWrapper>
            </StyledBox>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CreateAccountPageLayout,
    definition: {
        group: "Layout" as any,
        displayName: "Create Account Page Layout",
        allowedContexts: ["AccountRegistrationPage" as any],
    },
};

export default widgetModule;
